import { IVector3 } from './gameplay';

export enum SpawnPointType {
	ESTATE = 'estate',
	ACTIVE_QUEST = 'active_quest',
	LAST_POSITION = 'last_position',
	JAIL = 'jail',
}

export interface ISpawnPointPayload {
	name: string;
	type: SpawnPointType;
	position: IVector3;
	heading: number;
}
